export default __webpack_public_path__ + "static/media/exempt.d11a3125.png";